<template>
  <qc-container title="品牌管理">
    <page-request ref="table" url="/api/mgr/business/brand/list" :table-header="tableHeader" :expend="expend" :prop="{type:type}" :op-width="200">
      <t-button @click="doEdit()">添加</t-button>
      <t-button @click="batchUpdateStatus(0)">批量启用</t-button>
      <t-button @click="batchUpdateStatus(1)">批量禁用</t-button>
      <t-button @click="batchDel()">批量删除</t-button>
      <template #op="scope">
        <b-button @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-show="scope.row.status===0" @click="updateStatus([scope.row.id],1)">禁用</b-button>
        <b-button v-show="scope.row.status===1" @click="updateStatus([scope.row.id],0)">启用</b-button>
        <b-button @click="doDel([scope.row.id])">删除</b-button>
      </template>
    </page-request>
    <BrandAdd ref="add" @load="pageReloadData"></BrandAdd>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";
import BrandAdd from "./op/brand-add.vue";


export default {
  props:{
    //类型 0线上商品 1租售商品
    type:{
      type:Number,
      default:0
    }
  },
  name: 'brand-list',
  components: {QcContainer, PageRequest, TButton, BButton, BrandAdd},
  data() {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {prop: "name", label: "品牌名称"},
        {prop: "sort", label: "排序",width:100},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "品牌名称", prop: "name"},
        {label: "状态", prop: "status",type:"select",options:[{"label":"正常","value":"0"},{"label":"禁用","value":"1"}]},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doEdit(row) {
      this.$refs.add.open(row,this.type);
    },
    doDel(ids) {
      this.msgConfirm("/api/mgr/business/brand/delete", {ids: ids}, () => {
        this.pageReloadData();
      });
    },
    batchUpdateStatus(status) {
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.updateStatus(ids,status);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    updateStatus(ids,status){
      this.msgConfirm("/api/mgr/business/brand/updateStatus",{ids:ids,status:status},()=>{
        this.pageReloadData();
      },`您是否要${status?'禁用':'启用'}所选品牌?`)
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>

</style>
